export function accountProtectionMessage(response, t) {
  const code = response?.errorCode || response?.error?.code || response?.message;
  if (response?.statusCode === 423 || code === 'ACCOUNT_REVIEW_REQUIRED') return t('brand:accountReviewRequired', {
    defaultValue: 'Your account needs a review. Your draft has not been published and is still here. You can request a review in Settings → Account.',
  });
  if (code === 'ACCOUNT_RATE_LIMITED' && response?.retryAfter > 0) return t('brand:accountRateLimitedUntil', {
    minutes: Math.max(1, Math.ceil(response.retryAfter / 60)),
    defaultValue: 'Please try again in about {{minutes}} min. Your draft is still here.',
  });
  if (code === 'ACCOUNT_RATE_LIMITED') return t('brand:accountRateLimited', {
    defaultValue: 'Please pause before trying again. Your draft is still here.',
  });
  return null;
}
